import apiClient from "@/services/apiClient";

export async function getCourses({ page = 1, search = "", category = "", per_page, sort = "", skill_level = "", instructor = "" } = {}) {
  const { data } = await apiClient.get("/public/courses", {
    params: { page, search, category, per_page, sort, skill_level, instructor },
  });
  return data;
}

export async function getCategories() {
  const { data } = await apiClient.get("/public/categories");
  return data;
}

// Powers the navbar's "Explore" mega-menu -- each category with a handful of its own real,
// live course titles, replacing the old hardcoded AppDatas/categories.js sub-item list.
export async function getCategoryMenu(perCategory = 8) {
  const { data } = await apiClient.get("/public/categories/menu", {
    params: { per_category: perCategory },
  });
  return data;
}

export async function getPlatformStats() {
  const { data } = await apiClient.get("/public/platform-stats");
  return data;
}

// `params` forwards straight to the backend's PublicInstructorsFetcher -- pass `{ limit }` for a
// flat capped list (e.g. the homepage carousel's top 15), or `{ page, per_page }` for the
// paginated listing the dedicated /instructors page uses. No params => unchanged, full flat list.
export async function getInstructors(params = {}) {
  const { data } = await apiClient.get("/public/instructors", { params });
  return data;
}

export async function getCourseDetail(courseId) {
  const { data } = await apiClient.get(`/public/course-details/${courseId}`);
  return data;
}

// Requires auth (routed through the authenticated backend proxy, not the public one) --
// the caller should catch a 401 and redirect to login if the visitor isn't signed in yet.
export async function enrollInCourse(courseId) {
  const { data } = await apiClient.post(`/backend/dashboard/courses/${courseId}/enroll`);
  return data;
}

// "Recommended for you" -- other published courses ranked by category overlap with what the
// student is already enrolled in (average rating + enrollment count as tiebreakers), falling
// back to platform-wide trending courses for a brand-new student with no enrollments yet. See
// CoursesRepositories::StudentRecommendedCoursesFetcher on the backend.
export async function getRecommendedCourses(limit = 10) {
  const { data } = await apiClient.get("/backend/dashboard/courses/recommendations", {
    params: { limit },
  });
  return data;
}
